<template>
  <div class="container">
    <div class="m-2 col-sm-12">
      <h4
        v-if="showFailureMessage"
        class="bg-danger text-white text-center p-2 my-2"
      >
        Uwierzytelnianie nie powiodło się. Spróbuj ponownie.
      </h4>
      <div class="form-group">
        <label>Nazwa użytkownika</label>
        <input
          v-model="$v.username.$model"
          class="form-control"
        >
        <validation-error :validation="$v.username" />
      </div>
      <div class="form-group">
        <label>Hasło</label>
        <input
          v-model="$v.password.$model"
          type="password"
          class="form-control"
        >
        <validation-error :validation="$v.password" />
      </div>
      <div class="text-center">
        <button
          class="btn btn-theme-add"
          @click="handleAuth"
        >
          Zaloguj
        </button>
      </div>
    </div>
  </div>
</template>
<script>
    import {required} from "vuelidate/lib/validators";
    import {mapActions, mapState} from "vuex";
    import ValidationError from "./ValidationError";

    export default {
        components: {ValidationError},
        data: function () {
            return {
                username: "",
                password: "",
                showFailureMessage: false
            };
        },
        computed: {
            ...mapState({authenticated: state => state.auth.authenticated})
        },
        validations: {
            username: {required},
            password: {required}
        },
        methods: {
            ...mapActions(["authenticate", "createPost"]),
            handleAuth() {
                this.authenticate({
                    username: this.username,
                    password: this.password
                });
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.authenticate({
                        username: this.username,
                        password: this.password
                    });
                    if (this.authenticated) {
                        this.$router.push("/customers");
                    } else {
                        this.showFailureMessage = true;
                    }
                }
            }
        }
    };
</script>
<style scoped>
    body {
        background-color: black;
        opacity: 0.5;
    }
</style>
